import { useTrackingWrapper } from '@hooks/use-tracking-wrapper'
import { EVENT } from '@utils/tracking/constants'
import { type SyntheticEvent, useCallback } from 'react'

export const useTrackMenuLink = () => {
  const wrapper = useTrackingWrapper()

  return useCallback(
    (label: string, categoryLabel: string, menuLabel: string) =>
      (event: SyntheticEvent) => {
        if (wrapper) {
          wrapper.triggerEvent(EVENT.CLICK, event.currentTarget, {
            click: label,
            click_chapter1: 'menu',
            click_chapter2: menuLabel,
            click_chapter3: categoryLabel,
          })
        }
      },
    [wrapper]
  )
}
